module.exports = "/assets/bb9a85b736f18939e112836e090359ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/DY.png
// module id = 1318
// module chunks = 0